<template>
  <div>
    <v-container class="container px-0 mb-8">
      <v-row
        class="title-row"
        :class="
          $vuetify.breakpoint.width <= 1400 ? 'flex-column flex-nowrap' : ''
        "
      >
        <v-col
          class="d-flex align-center"
          :style="
            $vuetify.breakpoint.width <= 1400
              ? ''
              : 'min-width: calc(100% - 482px); max-width: calc(100% - 482px)'
          "
        >
          <h4 class="font-weight-light text-gray" style="white-space: nowrap">
            {{ $t('heading.hosting.dns.title') }}
          </h4>
        </v-col>
        <v-col
          class="page-title__filter-controls justify-end align-end"
          :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
          :style="$vuetify.breakpoint.width <= 1400 ? '' : 'min-width: 482px'"
        > 
            <div class="acc-select-group mr-4">
              <div class="acc-select-label">
                {{ $t('heading.hosting.summary.hostingAccount') }}
                  <v-tooltip open-delay="150" bottom transition="custom-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-on="on" v-bind="attrs" size="16">$help</v-icon>
                    </template>
                    <div>
                      <p class="p-3 mb-0">
                        {{ $t('tooltip.hosting.summary.hostingAccount.tooltip') }}
                      </p>
                    </div>
                  </v-tooltip>
              </div>
              <v-select
                class="dns-zone"
                outlined
                :hide-details="true"
                v-model="zone"
                :items="zones.items"
                item-text="name"
                item-value="name"
                :loading="zones.loading"
                @change="reloadZoneRecords"
                return-object
                :menu-props="{
                  offsetY: true,
                  nudgeBottom: '8px',
                }"
                v-if="!records.loading && serverAccount && !serverAccount.diagnostic_mode"
              />
            </div>
         
          <active-server-account-selector
            v-if="service && service.dns_server_internal && service.server_accounts.length > 1"
            class="mr-4"
            :value.sync="serverAccount"
            :items="service.server_accounts"
          />
          <data-iterator-filter-controls
            v-if="!records.loading"
            :showSearchTerm="true"
            :searchTerm="records.search"
            :fullWidthSearch="false"
            @update:sortBy="changeSortBy"
            @update:sortDesc="handleSortDescChange"
            @update:searchTerm="handleSearchTermChange"
            :class="'my-hostings-search'"
          ></data-iterator-filter-controls>
          <v-btn
            v-if="!records.loading"
            :large="!$vuetify.breakpoint.smAndDown"
            elevation="0"
            color="primary"
            class="p-2 add-new-button page-title__add-button"
            @click="showAddRecordModal"
          >
            <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
              >$plus
            </v-icon>
            {{ $vuetify.breakpoint.mobile ? "" : $t('button.dns.add') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mt-3 px-0">
      <v-row>
        <v-col cols="12">
          <div :class="checkedItems.length > 0 ? 'pb-15' : ''">
            <hosting-dns-table
              v-if="serverAccount && !serverAccount.diagnostic_mode"
              :checkedItems="checkedItems"
              :headers="records.headers"
              :items="records.items"
              :itemsLoading="records.loading"
              :itemsPerPage="itemsPerPage"
              :itemsTotal="records.itemsTotal"
              :page="page"
              :possibleItemsPerPage="[[8, 16, 24]]"
              :searchTerm="searchTerm"
              :sortBy="sortBy"
              :sortDesc="sortDesc"
              @clearFilters="searchTerm = ''"
              @update:check-all="handleSelectAll"
              @update:checked-items="handleItemCheck"
              @update:itemsPerPage="changePerPage"
              @update:page="changePage"
              @update:sortBy="changeSortBy"
              @update:sortDesc="changeSortDesc"
              @toggle-proxy-status="toggleProxyStatus"
              :itemClass="itemClass"
            >
              <template v-slot:no-data>
                <TableFullScreenMessage
                  :title="$t('message.emptyTable.dns.title')"
                  :desc="$t('message.emptyTable.dns.description')"
                >
                  <template v-slot:image>
                    <hosting-dns-illustration />
                  </template>
                </TableFullScreenMessage>
              </template>

              <template v-slot:actions="item">
                <v-tooltip
                  transition="custom-tooltip"
                  open-delay="150"
                  bottom
                  z-index="99"
                  offset-overflow
                  nudge-bottom="4px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      icon
                      small
                      @click="showEditRecordModal(item)"
                    >
                      <v-icon>$edit2</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('button.dns.edit') }}</span>
                </v-tooltip>

                <v-tooltip
                  transition="custom-tooltip"
                  open-delay="150"
                  bottom
                  z-index="99"
                  offset-overflow
                  nudge-bottom="4px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      icon
                      small
                      @click="showDeleteRecordModal(item)"
                    >
                      <v-icon>$thrash</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('button.dns.delete') }}</span>
                </v-tooltip>
              </template>

              <template v-slot:mobile="{ item, headers }">
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[0])"
                  >
                    {{ $t('table.header.name') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.name }}</span>
                  </div>
                </div>
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[0])"
                  >
                    {{ $t('table.header.ttl') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.ttl }}</span>
                  </div>
                </div>
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[0])"
                  >
                    {{ $t('table.header.type') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.type }}</span>
                  </div>
                </div>
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[0])"
                  >
                    {{ $t('table.header.record') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.content }}</span>
                  </div>
                </div>
              </template>
            </hosting-dns-table>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      transition="custom-dialog-transition"
      :persistent="modalOptions.persistent"
      v-model="modalOptions.open"
      ref="dialog"
    >
      <div
        class="card-overlay"
        v-if="!modalOptions.persistent"
        @click="modalOptions.open = !modalOptions.open"
      />
      <div class="card-overlay" v-else @click="$refs.dialog.animateClick()" />
      <basic-modal
        style="width: 560px"
        :modalOptions="modalOptions"
        @modal-close="modalClose"
        :key="modalRender"
        ref="modal"
      />
    </v-dialog>
  </div>
</template>

<script>
import Api from "../../apis/Api";

import BasicModal from "../../components/modal/BasicModal";
import DataIteratorFilterControls from "../../components/dataIterator/DataIteratorFilterControls.vue";
import HostingDnsTable from "../../components/dataIterator/tables/HostingDnsTable.vue";
import HostingDnsIllustration from "../../components/illustrations/hosting/hosting-dns-illustration.vue";
import TableFullScreenMessage from "../../components/dataIterator/tables/TableFullScreenMessage.vue";

import ActionModalMixin from "../../mixins/ActionModalMixin";
import DataIteratorPageMixin from "../../mixins/DataIteratorPageMixin";
import CustomTablePageMixin from "../../mixins/CustomTablePageMixin";
import ActiveServerAccountSelector from "../../components/ActiveServerAccountSelector.vue";
import DnsActionsMixin from "../../mixins/DnsActionsMixin";

export default {
  components: {
    ActiveServerAccountSelector,
    BasicModal,
    DataIteratorFilterControls,
    HostingDnsTable,
    HostingDnsIllustration,
    TableFullScreenMessage,
  },
  mixins: [ActionModalMixin, DataIteratorPageMixin, CustomTablePageMixin, DnsActionsMixin],
  data() {
    return {
      dnsInstance: this.$route.params.instance,
      isServerProvided: false,
      zone: {},
      itemsPerPage: 8,
      searchTerm: "",
      sortBy: "",
      sortDesc: false,
      zones: {
        loading: true,
        items: [],
      },
      records: {
        loading: true,
        items: [],
        headers: [
          {
            text: 'name',
            value: "name",
            sortable: true,
          },
          {
            text: 'ttl',
            value: "ttl",
            sortable: true,
          },
          {
            text: 'type',
            value: "type",
            sortable: true,
          },
          {
            text: 'value',
            value: "content",
            sortable: true,
          },
          {
            text: 'actions',
            value: "actions",
          },
        ],
      },
      recordTypes: {
        loading: false,
        items: []
      },
      modalRender: 0,
      modalOptions: { open: false },
      page: 1,
      highlightItem: {},
      serverAccount: null
    };
  },
  props: {
    service: Object
  },
  watch: {
    highlightItem: function (newValue) {
      if (!newValue) return;
      setTimeout(() => {
        this.highlightItem = {};
      }, 1000);
    },
    service: function () {
      this.serverAccount = this.service.server_accounts[0];
    },
    serverAccount: function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.zones.items = [];
      this.records.loading = true;
      this.reloadZones();
      this.changeHeaders();
    },
    "modalOptions.open": function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
  methods: {
    passInstanceData() {
      if(this.dnsInstance){
        this.$emit('pass-instance', this.dnsInstance);
      }
    },
    reloadZoneRecords(zone = null) {
      if (zone !== null) {
        this.zone = zone;
      }
      this.records.loading = true;
      if (this.zone === null) {
        this.records.loading = false;
        return;
      }
      Api.get(
        `/services/${this.service.id}/dns/zones/${this.zone.id}/records`
      )
        .then((response) => {
          this.records.items = response.data.data.map((record) => {
            record.ttl = record.ttl === 1 ? "Auto" : record.ttl;
            record.loading = false;
            return record;
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.records.loading = false;
        });
    },
    reloadZones() {
      this.zones.loading = true;
      Api.get(`/services/${this.service.id}/dns/zones`)
        .then((response) => {
          this.zones.items = response.data.data;
          if (response.data.data.length) {
            this.zone = response.data.data[0];
            this.reloadZoneRecords();
            this.reloadRecordTypes();
          } else {
            this.records.items = [];
            this.records.loading = false;
          }
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.zones.loading = false;
        });
    },
    toggleProxyStatus(record) {
      record.loading = true;
      Api.patch(
        `/services/${this.service.id}/dns/zones/${this.zone.id}/records/${record.line}/toggle-proxy`
      )
        .then((response) => {
          record.proxied = response.data.data.proxied;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          record.loading = false;
        });
    },
    itemClass(item) {
      if (
        this.highlightItem.name &&
        item.name == this.highlightItem.name &&
        item.type == this.highlightItem.type
      ) {
        return "highlight";
      }
    },
    changeHeaders() {
      const proxiableHeader = {
        text: 'proxy',
        value: "proxied",
        sortable: false,
      };

      if (this.service.dns_server_type === 'cloudflare') {
        if (!this.records.headers.find(header => header.value === 'proxied')) {
          this.records.headers.splice(4, 0, proxiableHeader);
        }
      } else {
        this.records.headers = this.records.headers.filter(
          (header) => header.value !== "proxied"
        );
      }
    },
    reloadRecordTypes() {
      this.recordTypes.loading = true;
      Api.get(
        `/services/${this.service.id}/dns/record-types`
      )
        .then((response) => {
          this.recordTypes.items = response.data.data.map(type => {
            return {
              label: type,
              value: type
            }
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.recordTypes.loading = false;
        });
    }
  },
  mounted() {
    this.passInstanceData();
    if (this.service) {
      this.serverAccount = this.service.server_accounts[0];
      // this.reloadZones();
      // this.reloadRecordTypes();
      // this.changeHeaders();
    }
  },
};
</script>

<style scoped lang="scss">
.title-row {
  @media (min-width: 1401px) {
    height: 70px;
  }
}

.page-title__filter-controls {
  max-width: fit-content;
}

.text-gray {
  color: map-get($gray, darken1);
}
</style>
